export enum HolderType {
  OWNER_OCCUPIER = "Owner-occupier",
  INVESTOR = "Investor",
  FIRST_HOME_BUYER = "First Home Buyer",
  BUILDER_OR_CHANNEL_PARTNER = "Builder/Channel Partner",
}
